/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `OrdersPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  AddressSearch: {
    Placeholder: `عناوين تسليم البحث`,
  },
  PageHeading: ({ name }) => name,
  PageTitle: `أوامر`,
  Sidebar: {
    Address: {
      Heading: `بحث العنوان`,
    },
    OrderStatus: {
      Heading: `حالة الطلب`,
    },
  },
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  AddressSearch: {
    Placeholder: `Search delivery addresses`,
  },
  PageHeading: ({ name }) => name,
  PageTitle: `Orders`,
  Sidebar: {
    Address: {
      Heading: `Address`,
    },
    OrderStatus: {
      Heading: `Status`,
    },
  },
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  AddressSearch: {
    Placeholder: `搜索送货地址`,
  },
  PageHeading: ({ name }) => name,
  PageTitle: `订单`,
  Sidebar: {
    Address: {
      Heading: `地址`,
    },
    OrderStatus: {
      Heading: `状态`,
    },
  },
});
